import React, { useState, useEffect } from "react"
import _isEmpty from "lodash/isEmpty"

import Button from "@/components/core/Button/Button"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import ReCaptcha from "@/components/core/ReCaptcha/ReCaptcha"
import { getSiteWideModal, getShortenedUrl, getPageInfo } from "@/utils/helper"
import { addDataLayer } from "../analytics"

export default function SubmitFooter(props) {
  const {
    data,
    i18n,
    setData,
    onSubmit,
    formTitle,
    error: { subJobType = "" },
    termsAndConsLink,
    getInternalLinkURLS,
    legalPages,
    recaptchaAnalytics,
  } = props
  const [newsletterChecked, setNewsletterChecked] = useState(false)
  const [termsAndConsChecked, setTermsAndConsChecked] = useState(false)
  const [subJobError, setSubJobError] = useState(true)
  const [termsAndConditionsLink, setTermsAndConditionsLink] = useState(null)

  useEffect(() => {
    if (termsAndConsLink) {
      getTermsAndConsLink(termsAndConsLink)
    }
  }, [termsAndConsLink])

  const getTermsAndConsLink = async url => {
    const link = await getShortenedUrl(url)
    setTermsAndConditionsLink(link)
  }

  useEffect(() => {
    document.getElementById("contact-form-subJobType")
      ? !data.subJobType || subJobType
        ? setSubJobError(true)
        : setSubJobError(false)
      : setSubJobError(false)
  }, [data])

  const footerClickHandler = (e, link, title) => {
    addDataLayer({
      clickInternalLinks: getInternalLinkURLS(link),
      title: title.toLowerCase(),
      isLink: true,
      formTitle,
      url: link
        ? (link.indexOf("http") === -1 ? window.location.origin : "") + link
        : "n/a",
    })
    getSiteWideModal(e, link)
  }

  const checkDisabled = userdata => {
    if (
      userdata.fname.trim() &&
      userdata.lname.trim() &&
      userdata.email.trim() &&
      userdata.phone &&
      userdata.zipcode &&
      userdata.company.trim() &&
      userdata.address.trim() &&
      userdata.city.trim() &&
      userdata.state &&
      userdata.companyWebsite.trim() &&
      userdata.jobType.trim() &&
      userdata.termsAndConsCheck &&
      !subJobError
    )
      return false
    return true
  }

  return (
    <div className="trade-membership-footer">
      <div className="trade-membership-footer__checkbox">
        <div className="terms-conditions-check">
          <Checkbox
            value={i18n.termsAndConsCheck}
            checked={termsAndConsChecked}
            onChange={e => {
              setTermsAndConsChecked(!termsAndConsChecked)
              setData({ ...data, termsAndConsCheck: !termsAndConsChecked })
            }}
          />
          <a
            href={termsAndConditionsLink}
            className="terms-conditions-link"
            label={i18n.termsAndConsLabel}
            onClick={e =>
              footerClickHandler(
                e,
                termsAndConditionsLink,
                i18n.termsAndConsLabel
              )
            }
          >
            {i18n.termsAndConsLabel}
          </a>
        </div>
        <div className="newsletter-check">
          <Checkbox
            value={i18n.newsletterCheck}
            checked={newsletterChecked}
            onChange={e => {
              setNewsletterChecked(!newsletterChecked)
              setData({ ...data, newsletterCheck: !newsletterChecked })
            }}
          />
        </div>
      </div>
      <span className="trade-membership-footer__response-recieve-time">
        {i18n.timeNedded}
      </span>
      <Button
        className="trade-membership-footer__submit-button"
        role="button"
        id="submit-membership-form-button"
        disabled={checkDisabled(data)}
        onClick={onSubmit}
        type="black"
        label={i18n.submitButton}
        loading={props.loading}
        flexible
      />
      {!_isEmpty(recaptchaAnalytics) && (
        <ReCaptcha getAnalyticsData={recaptchaAnalytics} />
      )}
      <div className="trade-membership-policies">
        <a
          href="#"
          rel="noreferrer"
          onClick={e =>
            footerClickHandler(e, legalPages?.privacyPolicy, i18n.privacyPolicy)
          }
        >
          {i18n.privacyPolicy}
        </a>
        <a
          href="#"
          rel="noreferrer"
          onClick={e =>
            footerClickHandler(
              e,
              legalPages?.subjectAccessRequest,
              i18n.subjectAccessRequest
            )
          }
        >
          {i18n.subjectAccessRequest}
        </a>
        <a
          href="#"
          rel="noreferrer"
          onClick={e =>
            footerClickHandler(e, termsAndConditionsLink, i18n.termsOfService)
          }
        >
          {i18n.termsOfService}
        </a>
      </div>
    </div>
  )
}
